import React, { useContext, useState } from "react";
import { BI_AUT002Context } from "../context";
import { Row } from "reactstrap";
import { fnGetValueByKey } from "../../../helpers/functions";
import CardContextDynamic from "../../../components/Common/CardContextDynamic";
import { useSelector } from "react-redux";
import useGetHeightPage from "../../../Hooks/useGetHeightPage";
import TranspaleStringToComponente from "../../../components/Dynamic/TranspaleStringToComponente";
import CardDetailsUserImageDynamic from "../../../components/Common/CardDetailsUserImageDynamic";
import BizinBackend from "../../../helpers/bizin_helper";
import NotificationModal from "../../../components/Common/NotificationModal";

export default function GridBody() {

  const [notif, setNotif] = useState({
    isOpen: false,
    isReload: false,
    type: "success",
    message: "",
  });
  
  const { gridComponents, csrfToken, userFull } = useContext(BI_AUT002Context);
  const isModalPage = useSelector(state => state.Layout.isModalPage)

  const [preFilter, setPreFilter] = useState([])

  const headerComponentsRender = gridComponents.HEADER[0]?.Childrens

  const contextBlock = headerComponentsRender?.find(
    item => item.Chave_Transacao_Componente === 'CONTEXTO_001'
  )

  let canvasCompostoPayload = gridComponents.BODY[0]?.Childrens ?.find(
    item => item.Chave_Transacao_Componente === 'CANVAS_COMPOSTO_001'
  )

  let btnSubmit = gridComponents.BODY[0]?.Childrens ?.find(
    item => item.Chave_Transacao_Componente === 'BOTAO_SALVAR'
  )

  try {
    canvasCompostoPayload = JSON.parse(fnGetValueByKey(canvasCompostoPayload?.Childrens, "PROCEDURE_RESULTSET", false));
  } catch (error) {
    canvasCompostoPayload = []
    console.warn("CANVAS_COMPOSTO_001 não mapeado")
  }

  const form = fnGetValueByKey(gridComponents.BODY[0]?.Childrens, "FORMULARIO", false, 'Chave_Transacao_Componente')
  // const head = null //fnGetValueByKey(form[0]?.Childrens, "HEAD_FORMULARIO")
  // const groups = null // fnGetValueByKey(form[0]?.Childrens, "CONTROLE_GRUPO")

  useGetHeightPage();

  const handleSubmit = (e) => {
    e.preventDefault()
    const formData = new FormData(e.target);
    const formObject = Object.fromEntries(formData.entries());

    let procSave = fnGetValueByKey(btnSubmit?.Childrens, "PROCEDURE_SAVE")
    let procSaveParam = fnGetValueByKey(btnSubmit?.Childrens, "PROCEDURE_SAVE_PARAM")

    if(procSave && procSaveParam){
      procSaveParam = JSON.parse(procSaveParam)
      procSaveParam = procSaveParam.map((item) => {
        if(item.includes('<#CAMPOS_CONTEUDO#>')) {
          return JSON.stringify([formObject])
        }
        return item
      })

      const invalidFeedbacks = document.querySelectorAll('.invalid-feedback')
      const invalidInputs = document.querySelectorAll('.is-invalid')
      invalidInputs.forEach((item) => {
        item.classList.remove('is-invalid')
      })
      invalidFeedbacks.forEach((item) => {
        const input = item.parentElement.querySelector('input')
        input.classList.remove('is-invalid')
        item.remove()
      })

      try {
        BizinBackend.executeProcedure(Object.assign({}, procSaveParam), procSave, csrfToken, userFull?.access_token).then((resp) => {
          resp?.map((item) => {
            if(item.Status_Mensagem === 'E'){
              const element = document.getElementById(item.ID_Objeto_Mensagem)
              if(element) {
                element.classList.add('is-invalid')
                const invalidFeedback = document.createElement('div')
                invalidFeedback.classList.add('invalid-feedback')
                invalidFeedback.textContent = item.Texto_Mensagem
                element.parentElement.appendChild(invalidFeedback)
              }
            }

            if(item.Status_Mensagem === 'S'){
              setNotif((s) => ({ ...s, isOpen: true, message: "Dados salvos com sucesso!", type: "success" }))
            }
          })
        })
      } catch (error) {
        setNotif((s) => ({ ...s, isOpen: true, message: "Erro ao salvar dados, tente novamente.", type: "error" }))
        console.log("Erro to save form", error)
      }
    }
    
  }

  return (
    <React.Fragment>
      <NotificationModal
        isOpen={notif.isOpen}
        type={notif.type}
        message={notif.message}
        onClose={() => setNotif((s) => ({ ...s, isOpen: false }))}
      />
      <Row className="p-0 m-0">
        {gridComponents.BODY[0]?.Childrens.map((item, index) => (
          <div className="p-0" key={index}>
            {item?.Chave_Transacao_Componente === "FORMULARIO" && (
              <div className={`col-12 rounded-4 bg-white ${isModalPage ? 'p-0' : 'p-3'}`}>
                <CardDetailsUserImageDynamic data={canvasCompostoPayload} />
                {contextBlock?.Childrens && (
                  <div className="row">
                    <div className="col mb-4">
                      <CardContextDynamic contextBlock={contextBlock?.Childrens} isRenderModal={isModalPage} />
                    </div>
                  </div>
                )}
                <form className="row form-default-primary" onSubmit={handleSubmit}>
   
                {item?.Childrens.map((c, i) => (
                    <div key={i}>
                      {c?.Chave_Transacao_Componente.includes("CONTROLE_GRUPO") && (
                        <div className="col-12">
                          <div className="row">
                            <div className="col-12 mb-3">
                              {!!c?.Valor_Componente && <h4 className="font-size-20 text-color-azul1 font-w-600">
                                {c?.Valor_Componente}
                              </h4>}
                            </div>
                            <div className="col-12 pb-3 mb-2">
                              <div className="row">
                                {c?.Childrens.map((child, _k) => (
                                  <TranspaleStringToComponente key={_k} item={child} preFilter={preFilter} onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}/>
                                ))}
                              </div>
                              {i !== item.Childrens.length - 1 && (
                                <div className="border-bottom border-2 border-light-gray-06 pt-2"></div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                ))}
                  <div className="col d-flex justify-content-end gap-3">
                    <div className="col"></div>
                    {btnSubmit && (
                      <div className="col-3">
                        <button style={{ height: 52 }} type="submit" className={`w-100 btn bg-primary-dark text-white border-0 btn-hover-primary font-w-600 ${fnGetValueByKey(btnSubmit?.Childrens, "ESTILO")}`}>
                          {fnGetValueByKey(btnSubmit?.Childrens, "TITULO")  || "Texto não definido"}
                        </button>
                      </div>
                    )}
                  </div>
                </form>
              </div>
            )}
          </div>
        ))}
      </Row>
    </React.Fragment>
  );
}
